import { NIL, v5 as uuidv5 } from 'uuid';

import type { DraftJob } from 'src/graphql/generated';

export const generateIdempotencyKey = (draft: DraftJob) => {
  const {
    id,
    details,
    guidedDetails,
    isConfidential,
    locations,
    phoneNumber,
    salary,
    questionnaireId,
    summary,
    titles,
    video,
  } = draft;

  return uuidv5(
    JSON.stringify({
      id,
      details,
      guidedDetails,
      isConfidential,
      locations,
      phoneNumber,
      salary,
      questionnaireId,
      summary,
      titles,
      video,
    }),
    NIL,
  );
};
